module.exports = __webpack_public_path__ + "static/media/Youtube.9c1c9e31.svg";